import React from "react";
import {
  BrowserRouter,
  Route,
  Switch,
  Redirect,
  useLocation,
} from "react-router-dom";
import Home from "../pages/Home";
import YourWrapped from "../pages/YourWrapped";
import YourArt from "../pages/YourArt";
import About from "../pages/About";
import { Header, Footer, Loading, ErrorState } from "../components/UI";
import { useApp } from "../context";
function Guard({ children }) {
  const { ready, profile, sessionError, restore } = useApp();
  if (!ready) return <Loading text="Checking your connection" />;
  if (sessionError) return <ErrorState error={sessionError} retry={restore} />;
  return profile ? children : <Redirect to="/" />;
}
function ScrollToTop() {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo(0, 0);
    document.title =
      pathname === "/yourart"
        ? "Route art · Strava Wrapped"
        : pathname === "/yourwrapped"
          ? "Your year · Strava Wrapped"
          : "Strava Wrapped · Your year, in motion";
  }, [pathname]);
  return null;
}
export default function AppRouter() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <a className="skip-link" href="#main">
        Skip to content
      </a>
      <Header />
      <main id="main">
        <Switch>
          <Route exact path="/" component={Home} />
          <Route path="/yourwrapped">
            <Guard>
              <YourWrapped />
            </Guard>
          </Route>
          <Route path="/yourart">
            <Guard>
              <YourArt />
            </Guard>
          </Route>
          <Route path="/about" component={About} />
          <Route path="/redirect">
            <Redirect to="/?connection=authorization_failed" />
          </Route>
          <Route>
            <div className="empty-state">
              <h1>That route is off the map.</h1>
              <a className="button" href="/">
                Back to the start ↗
              </a>
            </div>
          </Route>
        </Switch>
      </main>
      <Footer />
    </BrowserRouter>
  );
}
